export default __webpack_public_path__ + "static/media/portfolio-hover-178.a1e3f4ad.jpg";